import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class transactionsSlipList_template extends vnTemplate{

    protected pagination: pagination_template;
    public validationsList: validationsList_template;
    protected filterAccount: filterDropdown_template;
    protected filterEntryType: filterDropdown_template;
    protected filterTransactionSystem: filterDropdown_template;
    protected filterCurrency: filterDropdown_template;
    protected filterPaymentsDate: filterDropdown_template;
    protected accountsFilter: multipleSelector_template;
    protected filterCompany: filterDropdown_template;
    protected resultsInfos: resultsInfo_template;

    protected getTemplateHtml(): string{

        return `
            <div class="sub-header w-justify">
                <div class="w-left">
                     <div><label for="idPayment" class="form-label form-label-box">Payment</label>` + this.filterPaymentsDate.getHtmlBuild() + `</div>
                     ${this.accountsFilter.getHtmlBuild()}
                     <div><label class="form-label form-label-box">Transaction System</label>` + this.filterTransactionSystem.getHtmlBuild() + ` </div>
                     <div><label class="form-label form-label-box">Currency</label>` + this.filterCurrency.getHtmlBuild() + ` </div>
                     <div><label class="form-label form-label-box">Entry Type</label>` + this.filterEntryType.getHtmlBuild() + ` </div>
                     <div><label class="form-label form-label-box">Company</label>` + this.filterCompany.getHtmlBuild() + ` </div>
                </div>

            </div>

            <div class="w-justify">
                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                       <div id="selected-accounts"></div>
                    </div>
                </div>
            </div>

            ` + this.validationsList.getHtmlBuild() + `

            <div class="list-header w-justify">

                <div class="w-left">
                    <button class="btn secondary icon i-export" type="button" data-bind="event: { click: onClickExport }, visible: (isShowExportVisible())">Full Detailed Export</button>
                    <button class="btn secondary icon i-export" type="button" data-bind="event: { click: onClickExportBankTransfer }, visible: (isShowExportVisible() && isBankTransferExportVisible())">Bank Transfer Export</button>
                    <button class="btn secondary icon i-export" type="button" data-bind="event: { click: onClickGeneratePaymentXML }, visible: (isShowExportVisible() && isPaymentXMLVisible())">Generate TD Payment XML</button>
                    <button class="btn secondary icon i-export" type="button" data-bind="event: { click: onClickACHPaymentExport }, visible: (isShowExportVisible() && isACHExportVisible())">ACH Export</button>
                    <a href="/"></a>
                </div>

                <div class="w-center">

                </div>

                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results" id="list-results">

                <table class="list-results">
                ` + this.resultsInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <!-- <th><span>View</span></th> -->

                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'userFullName') },         css: { 'list-sort-desc': orderByAndDirection()=='userFullName_DESC',       'list-sort-asc': orderByAndDirection()=='userFullName_ASC'}">user</span></th>
                            <th class="amount"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'amount') },                css: { 'list-sort-desc': orderByAndDirection()=='amount_DESC',               'list-sort-asc': orderByAndDirection()=='amount_ASC'}">Total</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'currency') },                css: { 'list-sort-desc': orderByAndDirection()=='currency_DESC',               'list-sort-asc': orderByAndDirection()=='currency_ASC'}">currency</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'paymentDate') },   css: { 'list-sort-desc': orderByAndDirection()=='paymentDate_DESC',  'list-sort-asc': orderByAndDirection()=='paymentDate_ASC'}">payment date</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: slips">
                        <tr>
                            <!-- <td class="button"  data-bind="event: { click: $parent.onClickView }" ></button></td> -->
                            <td class="userFullName"><span data-bind="text: userFullName"></span></td>
                            <td class="amount" ><span data-bind="text: amount"></span></td>
                            <td class="currency"><span data-bind="text: currency"></span></td>
                            <td class="paymentDate"><span data-bind="text: paymentDate"></span></td>
                        </tr>
                    </tbody>
                </table>

            </div>
            `;
    }

    protected initPartial(): void {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.filterEntryType = new filterDropdown_template("filterEntryType", this.getTemplateViewModel(), this.caller);
        this.filterEntryType.setLabel("Entry Type");
        this.filterCurrency = new filterDropdown_template("filterCurrency", this.getTemplateViewModel(), this.caller);
        this.filterCurrency.setLabel("Currency");
        this.filterAccount = new filterDropdown_template("filterAccount", this.getTemplateViewModel(), this.caller);
        this.filterAccount.setLabel("Account");
        this.filterTransactionSystem = new filterDropdown_template("filterTransactionSystem", this.getTemplateViewModel(), this.caller);
        this.filterTransactionSystem.setLabel("Transaction System");
        this.filterPaymentsDate = new filterDropdown_template("filterPaymentsDate", this.getTemplateViewModel(), this.caller);
        this.filterPaymentsDate.setLabel("Payment")
        this.accountsFilter = new multipleSelector_template('accountsFilter', this.getTemplateViewModel(), this.caller);
        this.accountsFilter.setLabel("Accounts");
        this.accountsFilter.setFilterContainerClass('margin-neg');
        this.accountsFilter.setTagContainerId('selected-accounts');
        this.accountsFilter.setTagContainerCaption('Selected Accounts:');
        this.filterCompany = new filterDropdown_template("filterCompany", this.getTemplateViewModel(), this.caller);
        this.filterCompany.setLabel("Company");
        this.resultsInfos = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{
        return "transactionsSlipList-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {
                     orderBy: ko.observable("paymentDate")
                    ,orderByDirection: ko.observable("ASC")
                    ,slips: ko.observableArray([])
                    ,orderByAndDirection: ko.observable("paymentDate_ASC")
                    ,idPayment: ko.observable("")
                    ,exportType: ko.observable("")
                    ,payments: ko.observable([])
                    ,isPrintVisible: ko.observable(false)
                    ,isShowExportVisible: ko.observable(false)
                    ,isACHExportVisible: ko.observable(false)
                    ,isBankTransferExportVisible: ko.observable(true)
                    ,isPaymentXMLVisible: ko.observable(true)
                    ,ironCorpCompanyId: ko.observable(null)
                    ,onClickReorder : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
                    ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); }
                    ,onClickView: function (data, event) { huit_neuf_this.onClickView(data); }
                    ,onClickExport: function (data, event) { huit_neuf_this.onClickExport(); }
                    ,onClickExportBankTransfer: function (data, event) { huit_neuf_this.onClickExportBankTransfer(); }
                    ,onClickGeneratePaymentXML: function (data, event) { huit_neuf_this.onClickGeneratePaymentXML(); }
                    ,onClickACHPaymentExport: function (data, event) { huit_neuf_this.onClickACHPaymentExport(); }
        };
    }


    public getViewModelForRequest() {

        return {
             orderBy: this.getTemplateViewModel().orderBy
            ,orderByDirection: this.getTemplateViewModel().orderByDirection
            ,orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            ,pagination: this.getTemplateViewModel().pagination
            ,filters: {
                 idPayment: this.getTemplateViewModel().filterPaymentsDate.selectedOption
                ,idEntryType: this.getTemplateViewModel().filterEntryType.selectedOption
                ,transactionSystem: this.getTemplateViewModel().filterTransactionSystem.selectedOption
                ,idCurrency: this.getTemplateViewModel().filterCurrency.selectedOption
                ,idAccounts: this.getTemplateViewModel().accountsFilter.selectedItems
                ,idCompany: this.getTemplateViewModel().filterCompany.selectedOption
            }
        }
    }

    public onClickReorder(value, data, event){
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.slipsListReorder();
    }

    public onChangeFilterAction(data) {

        if (data.idPayment() != null){
            this.getTemplateViewModel().isPrintVisible(true);
        }
        else{
            this.getTemplateViewModel().isPrintVisible(false);
        }

        this.updateExportButtonsVisibility();
        this.caller.filterSimpleOnChange();
    }

    public onClickView(data){
        this.caller.viewSlipDetail(data);
    }

    public setPayments(payments){
        this.getTemplateViewModel().payments(payments);
    }

    public setAccounts(accounts){
        this.accountsFilter.setItems(accounts);
        this.accountsFilter.setSelectedItems(accounts.filter(acc => {return acc.id < 4 || acc.id == 5}))

    }
    public setSlips(slips){
        this.getTemplateViewModel().slips(slips);
    }

    public setUsers(users){
        this.getTemplateViewModel().filterUser.users(users);
    }

    public onClickExport(){

        this.getTemplateViewModel().exportType('full')
        this.caller.getExportData();
    }

    public onClickExportBankTransfer(){

        this.getTemplateViewModel().exportType('bank transfer')
        this.caller.getExportData();
    }

    public onClickGeneratePaymentXML(){

        //this.getTemplateViewModel().exportType('bank transfer')
        this.caller.generatePaymentXML();
    }


    public onClickACHPaymentExport(){
        this.getTemplateViewModel().exportType('ach')
        this.caller.getACHExportData();
    }

    public setIsShowExportVisible(isShowExportVisible: boolean){
        this.getTemplateViewModel().isShowExportVisible(isShowExportVisible);
    }

    public setPaymentDateOptions(options) {

        let paymentDates = [];
        for (let item of options)
        {
            paymentDates.push({id: item.id, name: item.datePaid})
        }

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterPaymentsDate.setOptions(paymentDates);
        this.onChangeFilterAction = temp;
    }

    public setEntryTypeOptions(options) {

        let entryTypes = [];
        entryTypes.push({id: null, name: "all"})
        for (let item of options)
        {
            entryTypes.push(item)
        }

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterEntryType.setOptions(entryTypes);
        this.onChangeFilterAction = temp;
    }

    public setCurrencyOptions(options) {

        let currencies = [];
        currencies.push({id: null, name: "all"})
        for (let item of options)
        {
            currencies.push({id: item.id, name: item.currency})
        }

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterCurrency.setOptions(currencies);
        this.onChangeFilterAction = temp;
    }


    public setTransactionSystemOptions(options) {

        let transactionSystems = [];
        transactionSystems.push({id: null, name: "all"})

        for (let item of options)
        {
            transactionSystems.push(item)
        }

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterTransactionSystem.setOptions(transactionSystems);
        this.onChangeFilterAction = temp;
    }

    public setCompanyOptions(options){

        let companies = [];
        companies.push({id: null, name: "all"})

        for (let item of options)
        {
            companies.push(item)
        }

        const temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};
        this.filterCompany.setOptions(companies);
        this.onChangeFilterAction = temp;

        try {
            const iron = options && options.find && options.find((c)=> (c.name||'').toLowerCase() === 'iron corp');
            if (iron) {
                this.getTemplateViewModel().ironCorpCompanyId(iron.id);
            }
        } catch (e) { /* do nothing */ }


        this.updateExportButtonsVisibility();
    }


    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultsInfos.setExecutionTime(execTime);
        this.resultsInfos.setNbResults(nbResults);
        this.resultsInfos.setNbPages(nbPages);
    }

    public updateExportButtonsVisibility() {
        try {
            const vm: any = this.getTemplateViewModel();
            const selectedCompanyId = vm.filterCompany && vm.filterCompany.selectedOption ? vm.filterCompany.selectedOption() : null;
            const ironId = vm.ironCorpCompanyId ? vm.ironCorpCompanyId() : null;
            const isIron = (ironId != null && selectedCompanyId === ironId);

            // - When Iron Corp is selected: hide 'Bank Transfer Export' and 'Generate TD Payment XML', show 'ACH Export'
            // - Otherwise: show 'Bank Transfer Export' and 'Generate TD Payment XML', hide 'ACH Export'
            vm.isACHExportVisible(!!isIron);
            vm.isBankTransferExportVisible(!isIron);
            vm.isPaymentXMLVisible(!isIron);
        } catch (e) {
            // Fallback: show non-ACH by default
            const vm: any = this.getTemplateViewModel();
            vm.isACHExportVisible(false);
            vm.isBankTransferExportVisible(true);
            vm.isPaymentXMLVisible(true);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsSlipList_template.ts